/**
 * Contact types and interfaces
 */
// Integration source enum
export var IntegrationSource;
(function (IntegrationSource) {
    IntegrationSource["BUILDIUM"] = "BUILDIUM";
    IntegrationSource["APPFOLIO"] = "APPFOLIO";
    IntegrationSource["RENT_MANAGER"] = "RENT_MANAGER";
    IntegrationSource["RENTVINE"] = "RENTVINE";
    IntegrationSource["HUBSPOT"] = "HUBSPOT";
    IntegrationSource["DOORLOOP"] = "DOORLOOP";
    IntegrationSource["LEAD"] = "LEAD";
})(IntegrationSource || (IntegrationSource = {}));
//# sourceMappingURL=contact.js.map